import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Perdés tiempo valioso buscando material ambiental que casi nunca tiene ejemplos argentinos', 'Tus alumnos se desconectan porque los ejemplos son de otros países en lugar del Riachuelo, la Puna o el Delta del Paraná', 'No sabés cómo conectar la gestión ambiental con la actualidad del país (litio, Vaca Muerta, deforestación, cambio climático)', 'Cada vez que querés implementar un proyecto escolar ambiental empezás de cero sin guía profesional', 'Tus evaluaciones siempre son las mismas porque no tenés un banco de preguntas actualizado', 'Cuando llega el inicio del ciclo lectivo no tenés armada una secuencia didáctica completa y contextualizada', 'No tenés claridad sobre cómo implementar la Ley 27.621 de Educación Ambiental Integral en tu práctica docente', 'Querés profundizar tus conocimientos pero no encontrás un recurso integrado, en español y con foco argentino', 'Sentís que el nivel de tus clases no está a la altura de lo que tus alumnos merecen'];
  return <section className="py-20 bg-[#f5efe1]" data-id="element-267">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-269">
          <h2 className="text-[22px] md:text-4xl font-black text-[#1e4230] mb-6 text-balance font-[Merriweather,_serif]" data-id="element-270">
            ❓ ¿Cuántas clases más vas a preparar sin tener el material
            correcto?
          </h2>

          <div className="space-y-6 text-lg text-[#4a4133] text-left md:text-center max-w-3xl mx-auto" data-id="element-271">
            <p className="text-[15px] leading-relaxed" data-id="element-272">
              Tal vez ya buscaste información ambiental en YouTube que no tiene
              secuencia didáctica ni ejemplos argentinos. Tal vez armás tus
              propias planificaciones desde cero cada ciclo lectivo. Tal vez
              cuando un alumno pregunta sobre el litio de la Puna, la
              deforestación del Chaco o el cambio climático en Argentina no
              tenés una respuesta que los enganche con la realidad del país.
            </p>
            <p data-id="element-273">
              <strong className="text-[#1e4230] text-[17px]" data-id="element-274">
                No es falta de vocación docente. Es que nadie armó el sistema
                completo para vos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white border border-[#e0d6bf] rounded-2xl p-6 md:p-8 shadow-[0_12px_30px_-18px_rgba(31,50,39,0.3)]" data-id="element-275">
          <h3 className="text-xl font-bold text-[#9c3f22] mb-6 text-center" data-id="element-276">
            😓 Esto te está pasando ahora mismo:
          </h3>
          <ul className="space-y-4" data-id="element-277">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-278">
                <div className="mt-1 bg-[#9c3f22]/10 p-1 rounded-full shrink-0" data-id="element-279">
                  <X className="w-4 h-4 text-[#9c3f22]" data-id="element-280" />
                </div>
                <span className="text-[#4a4133] font-medium text-[15px]" data-id="element-281">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-282">
          <p className="font-bold text-[#6f4e2e] text-[17px]" data-id="element-283">
            🎯 ¿Y si esta fuera la última semana que enseñás Gestión Ambiental
            sin tener todo el material resuelto?
          </p>
        </div>
      </div>
    </section>;
}